// extracted by mini-css-extract-plugin
export default {"link":"ObservationButton_link__i47sg","badgeColor":"ObservationButton_badgeColor__urHRN"};